import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from '../../utils/helpers';
import { signin } from '../../actions/auth';
import Input from '../common/input';
import logo from '../../styles/img/logo.png';


class Login extends Component {
  state = {
    email: '',
    password: '',
    errors: {},
  }

  componentDidMount() {
    const { isAuthenticated, history } = this.props;
    if (isAuthenticated) {
      history.push('/');
    }
  }

  validate = () => {
    const errors = {};
    const { email, password } = this.state;
    if (isEmpty(email)) {
      errors.email = 'Username is required';
    }
    if (isEmpty(password)) {
      errors.password = 'Password is required';
    }
    return errors;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate();
    if (!isEmpty(errors)) {
      this.setState({ errors: errors || {} });
    } else {
      const { email, password } = this.state;
      const userForm = {
        email,
        password,
      };
      const { dispatch, history } = this.props;
      dispatch(signin(userForm, () => {
        history.push('/');
      }));
    }
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  render() {
    const { email, password, errors } = this.state;
    const { isLoading, errorMessage } = this.props;
    return (
      <div className="login">
        <div className="login__card">
          <div className="login__logo-box">
            <img src={logo} alt="Isikhnas Logo" className="login__logo" />
          </div>
          {!isEmpty(errorMessage) && (<div className="login__error">{errorMessage}</div>)}
          <div className="login__form">
            <form onSubmit={this.handleSubmit} className="form">
              <Input
                type="text"
                name="email"
                placeholder="Email / Phone"
                value={email}
                label="Username"
                onChange={this.handleInputChange}
                error={errors.email}
              />
              <Input
                type="password"
                name="password"
                placeholder="Password"
                value={password}
                label="Password"
                onChange={this.handleInputChange}
                error={errors.password}
              />
              <div className="form__group u-center-text u-margin-bottom-small">
                <button disabled={isLoading} type="submit" className="btn btn--red btn--block">
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isLoading: state.loadingBar.default === 1,
  isAuthenticated: !isEmpty(state.auth.authenticated),
  errorMessage: state.auth.errorMessage,
});

export default connect(mapStateToProps)(Login);
